import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint flowtype-errors/enforce-min-coverage: 0 */

import { getClient, getClientApplication } from '../../cola/requests';
import { COLA_STATUS } from '../../cola/colaEnums';
import timeout from '../timeout';
import * as C from './constants';

var registeredAndExpired = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(webapiUrl, headers) {
    var _ref2, status, client, _ref3, applicationStatus, clientApplication;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getClient(webapiUrl, headers);

          case 2:
            _ref2 = _context.sent;
            status = _ref2.status;
            client = _ref2.client;
            _context.next = 7;
            return getClientApplication(webapiUrl, headers);

          case 7:
            _ref3 = _context.sent;
            applicationStatus = _ref3.status;
            clientApplication = _ref3.clientApplication;

            if (!(status === COLA_STATUS.OK && applicationStatus === COLA_STATUS.OK)) {
              _context.next = 14;
              break;
            }

            if (!(client.status === 'REGISTERED' && clientApplication.status === 'CLOSED' && clientApplication.resolutionDetail === 'EXPIRED')) {
              _context.next = 14;
              break;
            }

            if (!timeout(C.INTERVAL_REGISTER_AND_EXPIRED, C.INTERVAL_AM_REGISTER_AND_EXPIRED, 'registeredAndExpired')) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", {
              scenario: '[autostart-registeredAndExpired]',
              status: C.SCENARIO_USE
            });

          case 14:
            return _context.abrupt("return", {
              status: C.SCENARIO_SKIP
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function registeredAndExpired(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default registeredAndExpired;